<template>

	<div :class="{'menu-sub-items':true, hasHeading:!!title}" v-if="projectMenu.length>0">

		<h2 class="heading list-heading" v-if="title" v-html="title" />

		<div v-if="projectMenu.length >= 10" class="submenu-search">
			<input
				type="text"
				v-model="searchQuery"
				:placeholder="searchPlaceholder"
				class="submenu-search-input"
			/>
		</div>

		<div class="menu-sub-items-inner">

			<div
				:class="{'menu-sub-item':true,icon:showDevice}"
				v-for="(project, projectIndex) in filteredProjectMenu" 
				:key="'project-'+projectIndex" 
			>
				<router-link :to="project.link" exact @click.native="menuLinkClick">
					<font-awesome-icon 
						v-if="showDevice"
						:icon="project.device==='desktop'?'desktop':'mobile-alt'" 
						:style="{ color: '#3b445b' }" 
					/>
					<span class="label"><font-awesome-icon icon="pause-circle" style="color: #f1492a; opacity:0.5;position: static;width: 15px;" v-if="!project.active&&pageType==='RankTracking'" /> {{project.name}}</span> 
				</router-link>
				<a :href="project.link" target="_blank" class="external" :title="'Open ' + project.name + ' in a new tab'"><font-awesome-icon icon="external-link-alt" :style="{ color: '#3b445b' }" /></a>
			</div>

		</div>
    </div>
	

</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'SubMenu',
	props: {
		pageType: { // RankTracking or DataDive
			type: String
		},
		showHeading: {
			type: Boolean,
			default: false
		},
		searchPlaceholder: {
			type: String,
			default: 'Search projects...'
		}
	},
	data() {
		return {
			searchQuery: ''
		}
	},
	computed: {

		...mapState('general',['projectList']),

		title () {

			if ( !this.showHeading ) return null;

			switch ( this.pageType ) {

				case 'RankTracking':

					return 'Rank Tracking';

				break;

				case 'DataDive':

					return 'Data Dive';

				break;

				case 'Insights':

					return 'Project Insights';

				break;

			}

			return null;

		},

		showDevice () {

			return this.pageType === 'RankTracking';

		},

		projectMenu () {

			return this.processMenu();

		},

		filteredProjectMenu() {
			if (!this.searchQuery) return this.projectMenu;
			const q = this.searchQuery.toLowerCase();
			return this.projectMenu.filter(p =>
				p.name.toLowerCase().includes(q)
			);
		}

	},
	methods: {

		menuLinkClick () {

			this.$emit('menuLinkClick');

		},
		processMenu ( ) {

			let projects = this.projectList, 
				projectList = [];

			projects.forEach ( function ( project ) {

				if ( !project['has' + this.pageType] ) return;

				let p = {
					name: this.pageType === 'DataDive' ? project.url.replaceAll('https://','').replaceAll('/','') : project.name,
					active: !!project.active
				};

				if ( this.showDevice ) p.device = project.device;

				switch (this.pageType) {

					case 'RankTracking':

						if ( !project.active ) return;

						p.link = '/rank-tracking/' + project._id;

					break;

					case 'DataDive':

						p.link = '/data-dive/' + project._id + '/url';

						if ( !project.isDataDivePrimary ) return;

					break;

					case 'Insights':

						p.link = '/insights/' + project._id;

					break;

				}

				projectList.push(p);

			}.bind(this));

			return projectList;

		}

	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.menu-sub-items {

	position: absolute;
	left: 100%;
	background-color: #fff;
	padding: 10px 0;
	top: 0;
	width: 300px;

	.menu-sub-items-inner {

		max-height: 50vh;
		overflow-x: scroll;

	}

	&.hasHeading {

		padding-top: 0;
		border: 1px solid #fff;
		border-left: none;

	}

	.heading {

		font-size: 18px;
		padding: 20px 0 0 14px;
		margin: 0;

		&.list-heading {

			background: @darkContrast;
			padding: 7px 14px;
			color: #fff;

		}
	
	}

	.menu-sub-item {

		margin-top: 5px;
		position: relative;
		margin-right: 45px;

		&.icon {

			> a, > span {

				.label {

					padding-left: 45px;

				}

			}

		}

		.external {

			display: block;
			position: absolute;
			top: -1px;
			right: 5px;

			svg {

				width: 15px;

			}

		}

		&:last-child {

			margin-bottom: 0;

		}

		> a, > span {

			min-height: 20px;
			display: block;
			padding: 6px 0 0;
			text-decoration: none;

			.label {

				display: inline-block;
				padding: 0px 0 0 15px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				width: 100%;

			}

			svg, .svg {

				position: absolute;
				width: 20px;
				height: 20px;
				left: 14px;
				top: 6px;
				margin-top: 0;
				
			}

		}

		> a {

			.trans;

			&:hover {

				background-color: rgba(240, 243, 242, 0.5);

			}

		}

	}

}

@media screen and (max-width: 767px) {

	.menu-sub-items {

		position: relative;
		left: 0;
		width: 100%;
		top: 0;

		.list-heading {

			display: none;

		}

		.menu-sub-items-inner {

			padding: 0 0 0 50px;

		}
		
		
	}

}

.submenu-search {
	padding: 8px 14px 0px 14px;
}
.submenu-search-input {
	width: 100%;
	padding: 6px 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 14px;
	outline: none;
	&:focus {
		border-color: @formDefaultColour;
	}
}

</style>